import { memo } from 'react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {}

export const LoadingSpinner = memo(({ className, ...props }: LoadingSpinnerProps) => {
  return (
    <div 
      className={cn("flex h-[50vh] items-center justify-center", className)} 
      {...props}
    >
      <div className="relative">
        <div className="h-24 w-24 rounded-full border-t-2 border-b-2 border-gray-900 dark:border-gray-100 animate-spin"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-sm text-gray-600 dark:text-gray-300">
          Loading...
        </div>
      </div>
    </div>
  );
});

LoadingSpinner.displayName = 'LoadingSpinner';
